export default "__VITE_ASSET__d262c6b1__"